const rankings = [
  {
    rank: 1,
    title: '秘密恋爱笔记',
    tag: '恋爱',
    views: '1,280万',
    desc: '从暗恋到双向奔赴的甜蜜校园故事，更新至128话',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20fantasy%20thumbnail%20art%20featuring%20couple%20illustration%20with%20warm%20sunset%20colors%20soft%20dreamy%20atmosphere%20miniature%20cover%20style%20clean%20simple%20composition%20warm%20lighting&width=400&height=300&seq=rank-kr-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '剑与魔法纪元',
    tag: '奇幻',
    views: '1,150万',
    desc: '热血奇幻冒险史诗，剑与魔法的壮丽世界等你探索',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20adventure%20thumbnail%20art%20featuring%20hero%20character%20pose%20dynamic%20warm%20lighting%20miniature%20cover%20style%20crisp%20clean%20background%20golden%20tones&width=400&height=300&seq=rank-kr-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '花都王朝',
    tag: '古风',
    views: '980万',
    desc: '宫闱深处的爱恨情仇，华美古风韩漫巅峰之作',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20thumbnail%20art%20featuring%20elegant%20characters%20in%20traditional%20costume%20with%20warm%20golden%20lighting%20soft%20background%20miniature%20cover%20style%20romantic%20atmosphere&width=400&height=300&seq=rank-kr-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '暗夜追踪者',
    tag: '悬疑',
    views: '860万',
    desc: '环环相扣的悬疑推理，第三季重磅回归再掀热潮',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dark%20mystery%20thriller%20thumbnail%20art%20featuring%20atmospheric%20scene%20with%20warm%20amber%20dramatic%20lighting%20miniature%20cover%20style%20moody%20composition%20clean%20background&width=400&height=300&seq=rank-kr-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '咖啡馆的午后',
    tag: '日常',
    views: '720万',
    desc: '治愈人心的日常故事，每一个平凡瞬间都闪闪发光',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20healing%20slice%20of%20life%20thumbnail%20art%20featuring%20peaceful%20cafe%20scene%20with%20warm%20sunlight%20miniature%20cover%20style%20serene%20comforting%20atmosphere%20soft%20lighting&width=400&height=300&seq=rank-kr-05&orientation=landscape',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热门排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          根据阅读量实时更新，看看大家都在追哪些韩漫
        </p>

        <div className="space-y-4">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 md:gap-6 bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer group"
              data-product-shop
            >
              <div className={`shrink-0 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading font-bold text-lg ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-secondary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="w-20 h-14 md:w-24 md:h-16 shrink-0 rounded overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`韩漫排行 - ${item.title}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">
                  {item.desc}
                </p>
              </div>

              <div className="shrink-0 text-right">
                <span className="text-sm md:text-base font-heading font-bold text-primary-500 whitespace-nowrap">
                  {item.views}
                </span>
                <p className="text-xs text-foreground-400 whitespace-nowrap">累计阅读</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}